// import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'
import { Provider } from 'react-redux';
import store from './store';

// DEBUG: captura stack trace completo del error
window.onerror = (msg, src, line, col, error) => {
  console.error('[GLOBAL ERROR]', msg);
  console.error('[ERROR FILE]', src);
  console.error('[ERROR LINE:COL]', line + ':' + col);
  console.error('[STACK TRACE]', error?.stack || '(no stack - iOS Safari omite stack en call stack overflow)');
};
window.addEventListener('unhandledrejection', (e) => {
  console.error('[UNHANDLED REJECTION]', e.reason?.message);
  console.error('[STACK TRACE]', e.reason?.stack);
});

createRoot(document.getElementById('root')).render(
  // <StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </StrictMode>
)
